import React from 'react';


function StandardsRevisionAndUpdatePolicy() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Standards Revision and Update Policy</h1>

        <div className="space-y-12 text-gray-800">
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">1. Revision Philosophy</h2>
            <p className="leading-relaxed">
              The AASC acknowledges the rapid pace of AI development. Standards must evolve to remain relevant while providing stability for operators. This policy balances the need for currency with the need for predictability.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">2. Versioning Protocol</h2>
            <p className="leading-relaxed mb-4">
              The Council employs Semantic Versioning (MAJOR.MINOR) for all standards:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Major Versions (e.g., 2.0):</strong> Introduce new controls or significantly alter existing requirements. Require re-verification.</li>
              <li><strong>Minor Versions (e.g., 2.1):</strong> Clarify language or provide additional guidance without changing the fundamental control objective.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">3. Review Cycle</h2>
            <p className="leading-relaxed">
              Standards are subject to an annual review cycle. The Steering Committee evaluates industry feedback, incident data, and technological advancements to determine if revisions are necessary.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">4. Transition Period</h2>
            <p className="leading-relaxed">
              Upon the release of a Major Version, the Council establishes a transition period (typically 6-12 months). During this window, operators may maintain their status under the previous version but must transition before the period expires.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}

export default StandardsRevisionAndUpdatePolicy;